// Sistema de empresas y sucursales
export interface Branch {
  id: string
  name: string
  address: string
  companyId: number
  orderCutoffTime?: string
  deliveryStartTime?: string
  deliveryEndTime?: string
}

export interface Company {
  id: number
  name: string
  rnc: string
  logo?: string
  branches: Branch[]
  employees: number
  taxExempt: boolean
  subsidy: string
  orderCutoffTime: string
  deliveryStartTime: string
  deliveryEndTime: string
  contactName?: string
  contactEmail?: string
  contactPhone?: string
}

export const COMPANIES: Company[] = [
  {
    id: 1,
    name: 'CCD',
    rnc: '101-55555-1',
    logo: 'https://via.placeholder.com/200x80/F97316/ffffff?text=CCD',
    branches: [
      {
        id: 'ccd-1',
        name: 'STI Plaza Internacional',
        address: 'Av. Winston Churchill',
        companyId: 1,
        orderCutoffTime: '10:00',
        deliveryStartTime: '12:00',
        deliveryEndTime: '14:00',
      },
      {
        id: 'ccd-2',
        name: 'Torre CCD Centro',
        address: 'Av. 27 de Febrero',
        companyId: 1,
        orderCutoffTime: '10:00',
        deliveryStartTime: '12:00',
        deliveryEndTime: '14:00',
      },
      {
        id: 'ccd-3',
        name: 'CCD Santiago',
        address: 'Calle del Sol',
        companyId: 1,
        orderCutoffTime: '10:00',
        deliveryStartTime: '12:00',
        deliveryEndTime: '14:00',
      },
    ],
    employees: 145,
    taxExempt: true,
    subsidy: '50%',
    orderCutoffTime: '10:00',
    deliveryStartTime: '12:00',
    deliveryEndTime: '14:00',
    contactName: 'Carlos Martínez',
    contactEmail: 'contacto@ccd.com',
    contactPhone: '809-555-0100',
  },
  {
    id: 2,
    name: 'Solugenix Dominicana',
    rnc: '101-55555-2',
    logo: 'https://via.placeholder.com/200x80/3B82F6/ffffff?text=Solugenix',
    branches: [
      {
        id: 'sol-1',
        name: 'Oficina Principal',
        address: 'Piantini',
        companyId: 2,
        orderCutoffTime: '10:30',
        deliveryStartTime: '12:30',
        deliveryEndTime: '14:30',
      },
    ],
    employees: 45,
    taxExempt: false,
    subsidy: 'RD$ 200',
    orderCutoffTime: '10:30',
    deliveryStartTime: '12:30',
    deliveryEndTime: '14:30',
    contactName: 'Ana López',
    contactEmail: 'ana.lopez@solugenix.com',
    contactPhone: '809-555-0200',
  },
  {
    id: 3,
    name: 'Banco Santa Cruz',
    rnc: '101-55555-3',
    logo: 'https://via.placeholder.com/200x80/10B981/ffffff?text=BSC',
    branches: [
      {
        id: 'bsc-1',
        name: 'Sucursal Principal',
        address: 'Av. Kennedy',
        companyId: 3,
        orderCutoffTime: '11:00',
        deliveryStartTime: '13:00',
        deliveryEndTime: '15:00',
      },
      {
        id: 'bsc-2',
        name: 'Sucursal Naco',
        address: 'Naco',
        companyId: 3,
        orderCutoffTime: '11:00',
        deliveryStartTime: '13:00',
        deliveryEndTime: '15:00',
      },
      {
        id: 'bsc-3',
        name: 'Sucursal Bella Vista',
        address: 'Bella Vista',
        companyId: 3,
        orderCutoffTime: '11:00',
        deliveryStartTime: '13:00',
        deliveryEndTime: '15:00',
      },
      {
        id: 'bsc-4',
        name: 'Sucursal Santiago',
        address: 'Santiago Centro',
        companyId: 3,
        orderCutoffTime: '11:00',
        deliveryStartTime: '13:00',
        deliveryEndTime: '15:00',
      },
    ],
    employees: 1200,
    taxExempt: true,
    subsidy: '100%',
    orderCutoffTime: '11:00',
    deliveryStartTime: '13:00',
    deliveryEndTime: '15:00',
    contactName: 'Roberto Fernández',
    contactEmail: 'rfernandez@bancosantacruz.com',
    contactPhone: '809-555-0300',
  },
  {
    id: 4,
    name: 'Banreservas',
    rnc: '101-55555-4',
    logo: 'https://via.placeholder.com/200x80/8B5CF6/ffffff?text=Banreservas',
    branches: [
      {
        id: 'br-1',
        name: 'Oficina Central',
        address: 'Av. Independencia',
        companyId: 4,
        orderCutoffTime: '10:00',
        deliveryStartTime: '12:00',
        deliveryEndTime: '14:00',
      },
      {
        id: 'br-2',
        name: 'Sucursal Duarte',
        address: 'Calle Duarte',
        companyId: 4,
        orderCutoffTime: '10:00',
        deliveryStartTime: '12:00',
        deliveryEndTime: '14:00',
      },
      {
        id: 'br-3',
        name: 'Sucursal La Vega',
        address: 'La Vega Centro',
        companyId: 4,
        orderCutoffTime: '10:00',
        deliveryStartTime: '12:00',
        deliveryEndTime: '14:00',
      },
    ],
    employees: 5000,
    taxExempt: true,
    subsidy: 'RD$ 300',
    orderCutoffTime: '10:00',
    deliveryStartTime: '12:00',
    deliveryEndTime: '14:00',
    contactName: 'María Santos',
    contactEmail: 'msantos@banreservas.com',
    contactPhone: '809-555-0400',
  },
]

export function getCompaniesList() {
  return COMPANIES.map((c) => ({
    id: c.id,
    name: c.name,
    rnc: c.rnc,
    logo: c.logo,
    branches: c.branches.length,
    employees: c.employees,
    taxExempt: c.taxExempt,
    subsidy: c.subsidy,
  }))
}

export function getBranchesByCompany(companyId: number): Branch[] {
  const company = COMPANIES.find((c) => c.id === companyId)
  return company?.branches || []
}

export function getCompanyById(companyId: number): Company | undefined {
  return COMPANIES.find((c) => c.id === companyId)
}

export function getCompanyByName(companyName: string): Company | undefined {
  return COMPANIES.find((c) => c.name === companyName)
}
